function getClientPosition(event) {
  if ("TouchEvent" in window && event instanceof window.TouchEvent) {
    var touch = event.touches[0];
    return touch.clientX;
  }

  return event.clientX;
}

export { getClientPosition };